import React from 'react';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import logoImg from '../assets/images/logo.png';

export default function TopBar() {
  return (
    <header className="topbar">
      <div className="container topbar-inner">
        <div className="logo">
          <img src={logoImg} alt="Moro" className="logo-img" />
        </div>
        <div className="topbar-right">
          <div className="social">
            <a href="https://www.instagram.com/moro.fyi/" aria-label="Instagram" title="Instagram" target="_blank" rel="noopener noreferrer"><FaInstagram className="icon-instagram" /></a>
            <a href="https://www.tiktok.com/@morofyi" aria-label="TikTok" title="TikTok" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
          </div>
          <a className="btn btn-pill btn-dark" href="#cta">Join Waitlist</a>
        </div>
      </div>
    </header>
  );
}